/**
 * Invoice Query Hooks
 * Handles billing invoices from Stripe
 */

import { useQuery } from '@tanstack/react-query';
import api from '../../utils/api.js';
import { queryKeys } from '../../lib/queryKeys.js';

/**
 * Get billing invoices
 * @param {Object} invoiceOptions - { limit: number }
 */
export function useInvoices(invoiceOptions = { limit: 10 }, queryOptions = {}) {
    return useQuery({
        queryKey: queryKeys.invoices(invoiceOptions),
        queryFn: async () => {
            const response = await api.getBillingInvoices(invoiceOptions);
            return response;
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes cache
        ...queryOptions,
    });
}

export default {
    useInvoices,
};
